import React from 'react';
import { Box } from '@mui/material';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { FileUpload } from '@/components/FileViewer';
import { ICarrier } from '@/types';

const MAX_SIZE = 20 * 1024 * 1024; // 20MB

interface InsurerDocsUploadFieldProps {
  uploadUrl: string;
  borderStyle?: '1px' | '1.5px';
  iconSize?: number;
  typographyVariant?: 'body2' | 'body1';
  listItemStyles?: {
    pb?: number;
    pt?: number;
    avatarMinWidth?: string;
    avatarWidth?: number;
    avatarHeight?: number;
  };
}

const InsurerDocsUploadField: React.FC<InsurerDocsUploadFieldProps> = ({
  uploadUrl,
}) => {
  const form = useFormContext<ICarrier>();
  const { control } = form;

  const {
    fields: documentsFields,
    append: appendDocuments,
    remove: removeDocuments,
  } = useFieldArray({
    control,
    name: 'insuranceDocuments' as const,
  });

  const {
    append: appendDeleteFiles,
  } = useFieldArray({
    control,
    name: 'deleteInsuranceFiles' as any,
  });

  return (
    <Box>
      <FileUpload
        files={documentsFields as any}
        onAdd={(acceptedFiles) => {
          const newFiles = acceptedFiles.map((file) => ({
            file,
            name: file.name,
            extension: file.name.split('.').pop(),
          }));
          appendDocuments(newFiles as any);
        }}
        onRemove={(index, fileItem) => {
          if ('filename' in fileItem) {
            appendDeleteFiles((fileItem as any).filename);
          }
          removeDocuments(index);
        }}
        uploadUrl={uploadUrl}
        accept={{
          'image/*': ['.jpeg', '.jpg', '.png'],
          'application/pdf': ['.pdf'],
          'application/msword': ['.doc'],
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
          'application/vnd.ms-excel': ['.xls'],
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
        }}
        maxSize={MAX_SIZE}
      />
    </Box>
  );
};

export default InsurerDocsUploadField;
